import { render } from "./FormatListNumbered.vue?vue&type=template&id=a3e3b322"
import script from "./FormatListNumbered.vue?vue&type=script&lang=js"
export * from "./FormatListNumbered.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__